import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { CustomerState } from './customer.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([CustomerState])],
  declarations: []
})
export class CustomerStoreModule {}
